import React from 'react';
import { Helmet } from 'react-helmet-async';

const Compliance = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <Helmet>
        <title>Compliance & Regulatory Information - TCPA, CTIA, A2P 10DLC | Cargo Engage</title>
        <meta name="description" content="Cargo Engage compliance commitment: TCPA regulations, CTIA guidelines, A2P 10DLC registration, financial services compliance, and data protection. 100% compliant lead generation." />
        <meta name="keywords" content="TCPA compliance, CTIA guidelines, A2P 10DLC, regulatory compliance, financial services regulations, data protection" />
      </Helmet>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Compliance & Regulatory Information</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <div style={{background: '#f0f9ff', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '2px solid #3b82f6'}}>
              <h2 style={{color: '#1e40af', marginBottom: '1rem'}}>Our Compliance Commitment</h2>
              <p>
                Cargo Engage is committed to maintaining the highest standards of compliance with all applicable 
                federal and state regulations governing lead generation, SMS marketing, and consumer protection. 
                We ensure that all lead generation activities adhere to industry best practices and legal requirements.
              </p>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>TCPA Compliance</h2>
            <p style={{marginBottom: '1rem'}}>
              We strictly adhere to the Telephone Consumer Protection Act (TCPA) requirements:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Prior express written consent required for all marketing messages</li>
              <li>Clear and conspicuous disclosure of message frequency and charges</li>
              <li>Easy opt-out mechanisms (STOP, UNSUBSCRIBE)</li>
              <li>Proper record-keeping of all consent and opt-out requests</li>
              <li>Compliance with calling time restrictions</li>
              <li>Regular consent verification and validation</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>CTIA Guidelines</h2>
            <p style={{marginBottom: '1rem'}}>
              All SMS campaigns follow CTIA (Cellular Telecommunications Industry Association) guidelines:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Clear opt-in and opt-out processes</li>
              <li>Transparent message frequency disclosure</li>
              <li>Proper identification of message senders</li>
              <li>SMS consent not transferable to third parties</li>
              <li>Compliance with carrier-specific requirements</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>A2P 10DLC Registration</h2>
            <p style={{marginBottom: '1rem'}}>
              Cargo Engage maintains A2P (Application-to-Person) 10DLC compliance:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Registered with The Campaign Registry (TCR)</li>
              <li>Business verification documentation on file</li>
              <li>Campaign registration for all messaging use cases</li>
              <li>Following carrier-specific requirements</li>
              <li>Monitoring carrier policy updates</li>
              <li>Proper message classification and content guidelines</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Financial Services Compliance</h2>
            <div style={{background: '#fff3cd', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #ffc107'}}>
              <p style={{fontWeight: '600', color: '#856404', marginBottom: '0.5rem'}}>
                Lead Generation for Financial Services:
              </p>
              <p style={{color: '#856404'}}>
                As a lead generation company serving the financial services industry, we comply with all applicable 
                regulations including clear disclosure that we are NOT a lender, proper consent for information sharing, 
                and the requirement that SMS consent is not required to obtain credit.
              </p>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Data Protection & Privacy</h2>
            <p style={{marginBottom: '1rem'}}>
              We implement comprehensive data protection measures:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Encryption of all customer data in transit and at rest</li>
              <li>Secure data storage and access controls</li>
              <li>Regular security audits and vulnerability assessments</li>
              <li>Data retention and deletion policies</li>
              <li>Employee training on data protection practices</li>
              <li>Compliance with state privacy laws</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Consumer Protection</h2>
            <p style={{marginBottom: '1rem'}}>
              We prioritize consumer protection through:
            </p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Clear disclosure of our role as a lead generator</li>
              <li>Transparent information sharing practices</li>
              <li>Easy-to-use opt-out mechanisms</li>
              <li>Prompt processing of consumer requests</li>
              <li>Quality control for lending partner network</li>
              <li>Complaint resolution procedures</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Industry Certifications</h2>
            <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '2rem'}}>
              <div style={{background: '#fff', padding: '1.5rem', borderRadius: '8px', border: '2px solid #e5e7eb', flex: '1', minWidth: '200px', textAlign: 'center'}}>
                <h4 style={{color: '#1e3c72', marginBottom: '0.5rem'}}>TCPA Compliant</h4>
                <p style={{fontSize: '0.9rem'}}>Following all TCPA regulations</p>
              </div>
              <div style={{background: '#fff', padding: '1.5rem', borderRadius: '8px', border: '2px solid #e5e7eb', flex: '1', minWidth: '200px', textAlign: 'center'}}>
                <h4 style={{color: '#1e3c72', marginBottom: '0.5rem'}}>A2P Registered</h4>
                <p style={{fontSize: '0.9rem'}}>Carrier-approved messaging</p>
              </div>
              <div style={{background: '#fff', padding: '1.5rem', borderRadius: '8px', border: '2px solid #e5e7eb', flex: '1', minWidth: '200px', textAlign: 'center'}}>
                <h4 style={{color: '#1e3c72', marginBottom: '0.5rem'}}>CTIA Guidelines</h4>
                <p style={{fontSize: '0.9rem'}}>Industry best practices</p>
              </div>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Compliance Monitoring</h2>
            <p style={{marginBottom: '2rem'}}>
              Our compliance program includes continuous monitoring and regular audits to ensure ongoing adherence 
              to all applicable regulations. We maintain detailed records of all campaigns, consent mechanisms, 
              and opt-out requests as required by law.
            </p>

            <div style={{background: '#fef2f2', padding: '2rem', borderRadius: '10px', border: '2px solid #ef4444'}}>
              <h3 style={{color: '#ef4444', marginBottom: '1rem'}}>Important Notice</h3>
              <p>
                This compliance information is provided for general guidance only and does not constitute legal advice. 
                Consumers and business partners should consult with qualified legal counsel regarding specific compliance requirements.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Compliance;
